import { useGetOnchainUserTxs as useGetOnchainUserTxsQuery } from '@xhype/card-app-sdk';
import { useAuthStore } from '@package/smart-wallet/store';

/* Types */
type UseGetOnchainUserTxsProps = {
  pageNum?: number;
  pageSize?: number;
  orderNo?: string;
  startTime?: number;
  endTime?: number;
  type?: string;
};

/* Hook */
export const useGetOnchainUserTxs = ({
  pageNum = 1,
  pageSize = 10,
  orderNo,
  startTime,
  endTime,
  type,
}: UseGetOnchainUserTxsProps) => {
  const id = useAuthStore((store) => store.id);

  /* Queries */
  const { data, isLoading, isError, error } = useGetOnchainUserTxsQuery({
    enabled: !!id,
    userId: id ?? 0,
    requestData: {
      pageNum,
      pageSize,
      orderNo,
      startTime,
      endTime,
      type,
    },
  });

  /* Return */
  return {
    isLoading,
    isError,
    error,
    total: data?.total,
    records: data?.records,
  };
};
